export class NotCoveredIndexes {
    DrugIndex!: number;
    NotesPublicIndex!: number;
}
